











































import Vue from 'vue';

export default Vue.extend({
  name: 'TransferModal',
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    step: 1,
  }),
  computed: {
    syncedViewDetails: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      },
    },
  },
});
